export const CustomFieldMetaData = {
    StringMaxLength: 4000,
    HyperLinkMaxLength: 500,
    TextAreaMaxLength: 4000,
    NumericMaxValue: 99999999999,
    NumericMinValue: -100000000000,
    NumericNumberMaxValue: 1000000000,
    NumericNumberMinValue: -10000000,
    DateMaxValue: 10,
};
